/**
 * systems/share.ts — v4 cleanup: typed, minimal, no dead code
 */

import type { EdgeSample } from "../edge/feed";

export async function shareEdgeCard(sample: EdgeSample | null): Promise<void> {
  const canvas = document.createElement("canvas");
  canvas.width = 1200;
  canvas.height = 630;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  const g = ctx.createLinearGradient(0, 0, 1200, 630);
  g.addColorStop(0, "#0a0a0a");
  g.addColorStop(1, "#16161c");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 1200, 630);
  ctx.strokeStyle = "rgba(255,255,255,0.12)";
  ctx.strokeRect(40, 40, 1120, 550);
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = '600 28px "IBM Plex Mono", monospace';
  ctx.fillText("DOORPOST  ·  EDGE", 80, 110);
  ctx.fillStyle = "#fff";
  ctx.font = '650 72px "DM Sans", sans-serif';
  ctx.fillText(sample?.colo ? String(sample.colo) : "—", 80, 220);
  ctx.font = '500 44px "IBM Plex Mono", monospace';
  ctx.fillText(sample ? String(sample.rttMs) + " ms" : "— ms", 80, 300);
  const loc = [sample?.city, sample?.country].filter(Boolean).join(", ");
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = '400 28px "DM Sans", sans-serif';
  ctx.fillText(loc || "measured at the edge", 80, 370);
  if (sample?.asn != null) ctx.fillText("AS" + sample.asn, 80, 420);
  ctx.fillText("doorpost.xyz", 80, 520);
  const dataUrl = canvas.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = "doorpost-edge.png";
  a.click();
}
